<template lang="pug">
.rhpa-link-swatches
  Swatches(
    :options="links"
    :label="label"
    :modelValue="$route.path"
    @update:modelValue="$router.push($event)"
  )
</template>
<script setup lang="ts">
defineProps({
  label: {
    type    : String,
    default : 'Related',
  },
  links: {
    type    : Array,
    default : () => ([]),
  },
})
</script>
<style lang="scss" scoped>
</style>
